import max from './max'
export default function (x, y) {
  return max(x, y)
}
